import L from "leaflet";
import * as alarmSeverityType from "./../shared/alarmSeverity.json";
import highRisk from "../../src/assets/images/high-priority.png"
import middleRisk from "../../src/assets/images/middle-priority.png"
import lowRisk from "../../src/assets/images/low-priority.png"
import marker from "../../src/assets/images/marker.png"
import normal from "../../src/assets/images/normal-priority.png"


let greenIcon = new L.Icon({
  iconUrl:normal,
  iconSize: [36, 37],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

let redIcon = new L.Icon({
  iconUrl: highRisk,
  iconSize: [36, 37],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

let redIconBlink = new L.Icon({
  iconUrl: highRisk,
  iconSize: [36, 37],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
  className: "blinking",
});

let orangeIcon = new L.Icon({
  iconUrl:middleRisk,
  iconSize: [36, 37],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

let orangeIconBlink = new L.Icon({
  iconUrl:middleRisk,
  iconSize: [36, 37],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
  className: "blinking",
});

let yellowIcon = new L.Icon({
  iconUrl:lowRisk,
  iconSize: [36, 37],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

let yellowIconBlink = new L.Icon({
  iconUrl:lowRisk,
  iconSize: [36, 37],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
  className: "blinking",
});

export const riskIcons = [
  greenIcon,
  redIcon,
  redIconBlink,
  orangeIcon,
  orangeIconBlink,
  yellowIcon,
  yellowIconBlink,
  marker,
];

export const iconPerAlertSeverityAndStatus = (alarmStatus, alarmSeverity) => {
  if (
    alarmStatus === 1 &&
    alarmSeverity === alarmSeverityType.ALARMSSEVERITY.LOWRISK
  ) {
    return riskIcons[6];
  }
  if (
    alarmStatus === 2 &&
    alarmSeverity === alarmSeverityType.ALARMSSEVERITY.LOWRISK
  ) {
    return riskIcons[5];
  }
  if (
    alarmStatus === 1 &&
    alarmSeverity === alarmSeverityType.ALARMSSEVERITY.MIDDLERISK
  ) {
    return riskIcons[4];
  }
  if (
    alarmStatus === 2 &&
    alarmSeverity === alarmSeverityType.ALARMSSEVERITY.MIDDLERISK
  ) {
    return riskIcons[3];
  }
  if (
    alarmStatus === 1 &&
    alarmSeverity === alarmSeverityType.ALARMSSEVERITY.HIGHRISK
  ) {
    return riskIcons[2];
  }
  if (
    alarmStatus === 2 &&
    alarmSeverity === alarmSeverityType.ALARMSSEVERITY.HIGHRISK
  ) {
    return riskIcons[1];
  }
  return riskIcons[0];
};
